import { render } from "./Station.vue?vue&type=template&id=58570306&scoped=true"
import script from "./Station.vue?vue&type=script&lang=js"
export * from "./Station.vue?vue&type=script&lang=js"

import "./Station.vue?vue&type=style&index=0&id=58570306&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58570306"]])

export default __exports__